module.exports = __webpack_public_path__ + "img/ps2zr0tiaaz6hu12myvkaomr06rh0flese1627b0e6-7c65-421a-8910-5a0531cbe88a.c151e854.png";